import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { TextBody } from '../text';
import { theme } from '@xbto/design-system';
export function RadioBox({ active = false, label, onPress, title, value, rounded, outlined, }) {
    // Handlers
    const handlePress = useCallback(() => {
        onPress === null || onPress === void 0 ? void 0 : onPress(value);
    }, [onPress, value]);
    // Render
    return (_jsx(Pressable, { onPress: handlePress, style: ({ pressed, hovered }) => [
            $.container,
            rounded && { borderRadius: Number(theme.radius.md) },
            pressed || hovered || active
                ? outlined
                    ? $.outlined
                    : $.active
                : undefined,
        ], children: ({ pressed, hovered }) => {
            const isActive = active || pressed || hovered;
            return (_jsxs(_Fragment, { children: [!!title && (_jsx(TextBody, { mb: "1", em: true, color: isActive && !outlined ? 'inverse' : 'primary', children: title })), _jsx(TextBody, { color: isActive && !outlined ? 'inverse' : undefined, children: label })] }));
        } }));
}
const $ = StyleSheet.create({
    container: {
        boxSizing: 'border-box',
        borderRadius: Number(theme.radius.sm),
        backgroundColor: theme.color.background.tertiary,
        padding: theme.spacing['4'],
        justifyContent: 'center',
        alignContent: 'center',
        outlineStyle: 'none',
        borderWidth: 2,
        // this border is necessary to avoid flickering when the component is focused
        borderColor: theme.color.background.tertiary,
    },
    active: {
        backgroundColor: theme.color.background.primary,
    },
    outlined: {
        borderColor: theme.color.background.primary,
    },
});
